module.exports = __webpack_public_path__ + "static/Bigcommerce-81a33a55e16adf12a4c4121898809359.png";